if (!customElements.get('sticky-atc-panel')) {
  class StickyAtcPanel extends HTMLElement {
    constructor() {
      super();

      this.productSection = this.closest('.cc-main-product');
      this.productInfo = this.productSection.querySelector('.product-info');
      this.productForm = this.productSection.querySelector('product-form');
      this.productSubmitButton = this.productForm?.querySelector('[name="add"]');
      this.stickySubmitButton = this.querySelector('[data-sticky-atc-submit]');

      if ('IntersectionObserver' in window && 'MutationObserver' in window) {
        this.bindEvents();
      }
    }

    // eslint-disable-next-line class-methods-use-this
    disconnectedCallback() {
      window.removeEventListener('scroll', StickyAtcPanel.handleScroll);
      this.stickySubmitButton?.removeEventListener('click', this.handleSubmit);
      this.buttonObserver?.disconnect();
    }

    bindEvents() {
      const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
          if (entry.target === this.productForm && !theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.boundingClientRect.bottom > 0);
          } else if (entry.target === this.productInfo && theme.mediaMatches.md) {
            this.classList.toggle('sticky-atc-panel--out', entry.isIntersecting);
          }
        });
      });

      if (this.productForm) observer.observe(this.productForm);
      if (this.productInfo) observer.observe(this.productInfo);

      if (this.productSubmitButton && this.stickySubmitButton) {
        this.handleSubmit = () => {
          if (this.productSubmitButton.disabled) {
            this.productForm.scrollIntoView({ behavior: 'smooth', block: 'center' });
            return;
          }

          this.productSubmitButton.click();
        };

        this.updateButtonState();
        this.stickySubmitButton.addEventListener('click', this.handleSubmit);
        this.buttonObserver = new MutationObserver(() => this.updateButtonState());
        this.buttonObserver.observe(this.productSubmitButton, {
          attributes: true,
          attributeFilter: ['disabled', 'aria-disabled']
        });
      }

      window.addEventListener('scroll', StickyAtcPanel.handleScroll);
    }

    updateButtonState() {
      const isDisabled = this.productSubmitButton.disabled || this.productSubmitButton.getAttribute('aria-disabled') === 'true';
      this.stickySubmitButton.disabled = isDisabled;
      this.stickySubmitButton.setAttribute('aria-disabled', isDisabled.toString());
    }

    /**
     * Watches for a scroll to the bottom of the page
     */
    static handleScroll() {
      document.body.classList.toggle(
        'scrolled-to-bottom',
        window.scrollY + window.innerHeight + 100 > document.body.scrollHeight
      );
    }
  }

  customElements.define('sticky-atc-panel', StickyAtcPanel);
}
